import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import EditorRoutes from 'foundation/EditorRoutes';
import navigateToURL from 'lib/navigateToURL';
import printerFriendlyViewHandler from 'routing/printerFriendlyViewHandler';
import {RouteBundle} from 'routing/RouteConstants';
import APIUtil from 'util/APIUtil';

export const WorkflowsRoutes: RouteBundle = {
  domain: 'workflows',
  routes: [
    {urlPattern: 'legacy-workflows', handler: legacyWorkflowDashboard, legacy: true},
    {urlPattern: 'workflows/templates', handler: legacyWorkflowDashboardTemplatesRedirector, legacy: true},
    {urlPattern: 'legacy-workflows/templates', handler: legacyWorkflowDashboardTemplates, legacy: true},
    {urlPattern: 'workflows/view/:workflowId', handler: legacyWorkflowDetailsRedirector, legacy: true},
    {urlPattern: 'legacy-workflows/view/:workflowId', handler: legacyWorkflowDetails, legacy: true},
    {
      urlPattern: 'workflows/stage-entries/:stageEntryUrlIdentifier',
      handler: legacyStageEntryEditorRedirector,
      legacy: true,
    },
    {
      urlPattern: 'legacy-workflows/stage-entries/:stageEntryUrlIdentifier',
      handler: legacyStageEntryEditor,
      legacy: true,
    },
    {
      urlPattern: 'workflows/stage-entries/:stageEntryUrlIdentifier/view',
      handler: printerFriendlyViewHandler,
      legacy: true,
    },
    {
      urlPattern: 'legacy-workflows/stage-entries/:stageEntryUrlIdentifier/view',
      handler: printerFriendlyViewHandler,
      legacy: true,
    },
    {
      urlPattern: 'workflows/templates/view/:workflowTemplateId',
      handler: legacyWorkflowTemplateViewRedirector,
      legacy: true,
    },
    {
      urlPattern: 'legacy-workflows/templates/view/:workflowTemplateId',
      handler: legacyWorkflowTemplateView,
      legacy: true,
    },
  ],
};

function legacyWorkflowDashboard(): void {
  EditorRoutes.workflowDashboard();
}

// Exported only for testing.
export function legacyWorkflowDashboardTemplatesRedirector(): void {
  if (BenchlingConfig.WORKFLOWS_ENABLE) {
    navigateToURL('legacy-workflows/templates', {replace: true});
  } else {
    legacyWorkflowDashboardTemplates();
  }
}

// Exported only for testing.
export function legacyWorkflowDashboardTemplates(): void {
  EditorRoutes.workflowDashboardTemplates();
}

function legacyWorkflowDetailsRedirector(workflowId: string): void {
  if (BenchlingConfig.WORKFLOWS_ENABLE) {
    navigateToURL(`legacy-workflows/view/${workflowId}`, {replace: true});
  } else {
    legacyWorkflowDetails(workflowId);
  }
}

function legacyWorkflowDetails(workflowId: string): void {
  EditorRoutes.workflowDetails(workflowId);
}

// Exported only for testing.
export function legacyStageEntryEditorRedirector(stageEntryId: string): void {
  if (BenchlingConfig.WORKFLOWS_ENABLE) {
    navigateToURL(`legacy-workflows/stage-entries/${stageEntryId}`, {replace: true});
  } else {
    legacyStageEntryEditor(stageEntryId);
  }
}

/*
 * This route supports two formats for stage entry URLs:
 * - Old:     /workflows/stage-entries/lGAhQYno
 * - Current: /workflows/stage-entries/stgentr_lGAhQYno
 *
 * While the backend already redirects the old-style URL to the current-style URL,
 * there are cases where the front-end may trigger single-page-app routing to an
 * old URL (e.g. when such a URL is stored within notebook contents). These URLs
 * may be stored indefinitely and so this route needs to be maintained indefinitely.
 */
// Exported only for testing.
export function legacyStageEntryEditor(stageEntryId: string): void {
  EditorRoutes.stageEntryEditor(APIUtil.withPrefixIfMissing(stageEntryId, ModelTypeConstants.STAGE_ENTRY));
}

function legacyWorkflowTemplateViewRedirector(workflowTemplateId: string): void {
  if (BenchlingConfig.WORKFLOWS_ENABLE) {
    navigateToURL(`legacy-workflows/templates/${workflowTemplateId}`, {replace: true});
  } else {
    legacyWorkflowTemplateView(workflowTemplateId);
  }
}

function legacyWorkflowTemplateView(workflowTemplateId: string): void {
  EditorRoutes.workflowTemplateView(workflowTemplateId);
}
